<template>
  <div id="app" v-loading.fullscreen.lock="loading">
    <el-container class="app-container">
      <el-main>
        <div class="basicInformation">
          <el-descriptions class="margin-top" :column="2" title="项目付款申请" size="medium" border>
            <template slot="extra">
              <el-button type="primary" size="small" @click="handleDownloadAll">一键下载</el-button>
            </template>
            <el-descriptions-item>
              <template slot="label">
                收款方式
                <el-popover placement="right" width="400" trigger="hover">
                  <h3>请仔细阅读以下说明</h3>
                  <p>如有<span>一次性收款</span>，直接选择“一次性收款并结项”</p>
                  <p>如有<span>分三次及三次以上收款</span>，第一次选择“申请首次收款”，第二次选择“申请尾款”</p>
                  <p>如有<span>分三次及三次以上收款</span>，第一次选择“申请首次收款”，中间付款选择“申请阶段收款”，最后一笔选择“申请尾款”
                  </p>
                  <p><span>据实结算</span>的收款方式仅支持费用类型是会议类，框架服务模式，按场次收款的项目，可多次申请</p>
                  <i class="el-icon-info" slot="reference"></i>
                </el-popover>
              </template>

              <template v-for="item in collectWayEnums">
                <span :key="item.value" v-if="item.value==slForm.collectWay">{{ item.label }}</span>
              </template>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                费用类型
              </template>
              <template v-for="item in feeTypeEnums">
                <span :key="item.value" v-if="item.value==slForm.feeType">{{ item.label }}</span>
              </template>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                项目名称
              </template>
              <span>{{ slForm.projectName ? slForm.projectName : '-' }}</span>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                供应商名称
              </template>
              <span>{{ slForm.supplierName ? slForm.supplierName : '-' }}</span>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                收款金额(元)
              </template>

              <!-- 格式化申请金额 -->
              {{ slForm.applyMoney }}
              <!-- 如果有中标金额，追加显示 -->
              <span v-if="slForm.totalPrice" class="budget-hint">
          （中标：{{ slForm.totalPrice }}） </span>
              <!--              <span>{{ slForm.applyMoney ? `${slForm.applyMoney}元` : '-' }}</span>-->
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                发票类型
              </template>
              <template v-for="item in receiptTypeEnums">
                <span :key="item.value" v-if="item.value==slForm.receiptType">{{ item.label }}</span>
              </template>
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                超出中标金额(元)
              </template>
              <span style="color: red">
                 <span>{{ slForm.isOverBudget == 1 ? `${slForm.overAmount}元` : '-' }}</span>
              </span>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                邮寄材料快递单号
              </template>
              {{ slForm.deliveryNum }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                创建时间
              </template>
              {{ $moment(slForm.createTime).format('lll') }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                费用申请单
              </template>
              <div style="display: flex; align-items: center;">
                <div>{{ slForm.applicationForm }}</div>
                <el-button style="margin-left: 2px;margin-top: 1px" type="text"
                           @click="openDialog(slForm.applicationForm)">修改
                </el-button>
              </div>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                项目负责人
              </template>
              {{ slForm.projectManager }}
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                费用报销单
              </template>
              {{ slForm.reimbursementNum }}
            </el-descriptions-item>


            <el-descriptions-item>
              <template slot="label">
                项目状态
              </template>
              <el-tag size="small">{{ formatStatus(slForm) }}</el-tag>
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                本次结算会议
              </template>
              <el-tag style="margin-right: 5px" v-for="(meeting, index) in selectedMeetings" :key="index">
                {{ meeting.meetingTitle }}）
              </el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </div>


        <!--这个服务评审中只有一次性收款， 或是尾款结算， 或是框架式的周期性的结算，才会有评审， 首款和中期款没有-->
        <div style="margin-top: 5px">
          <el-button v-if="!['1', '2'].includes(slForm.collectWay)" type="text"
                     @click="openServiceReview(slForm.supplierName,slForm.projectName)">
            查看供应商服务评审
          </el-button>
        </div>

        <div v-if="slForm.lastDetailDtos" v-for="(item, meetingIndex) in slForm.lastDetailDtos" :key="meetingIndex"
             class="basicInformation">
          <h3 style="font-weight: bolder">上次结算明细</h3>
          <el-table :data="item.details" style="width: 100%" show-summary
                    :summary-method="getspendingDetailSummaries" border>
            <el-table-column label="序号" width="80" type="index" align="center"></el-table-column>

            <el-table-column label="费用分类" align="center" prop="name">
<!--              <template #default="scope">-->
<!--                <el-select v-model="scope.row.spendingProjectCode" placeholder="请选择收款方式" disabled-->
<!--                           filterable clearable style="width: 100%;">-->
<!--                  <el-option v-for="detail in projectTree" :key="detail.id"-->
<!--                             :label="detail.projectType" :value="detail.id.toString()"/>-->
<!--                </el-select>-->
<!--              </template>-->
            </el-table-column>
            <el-table-column prop="money" label="金额(元)" align="center">
              <template #default="scope">
                {{ scope.row.money }}
                <!-- <el-input type="number" v-model.number="scope.row.money" placeholder="仅支持数字及小数点后2位"
                  :min="0" disabled @input="moneyChange(scope.$index, $event, meetingIndex, 'L')">
                  <template #append>元</template>
                </el-input> -->
              </template>
            </el-table-column>
            <el-table-column label="是否上传附件" align="center" width="110px">
              <template #default="scope">
                <el-tag v-if="scope.row.files && scope.row.files.length > 0"
                        type="success">是
                </el-tag>
                <el-tag v-else type="danger">否</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作" width="200" align="center" fixed="right">
              <template #default="scope">
                <el-button style="margin-right: 6px" type="text" @click="viewFilesWithSpendDetail(scope.row)">
                  查看附件
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>


        <div v-for="(item, meetingIndex) in processedMeetingList" :key="meetingIndex">
          <!-- 模块一：必须上传的附件 -->
          <div class="basicInformation">
            <div style="display: flex; align-items: center; justify-content: space-between; ">
              <h3 style="font-weight: bolder">必须上传的附件</h3>
              <el-button style="margin-right: 15px" type="text"
                         @click="bulkDownload(item.details[0].id,item.details[0].detailName)">下载
              </el-button>
            </div>
            <el-table :data="filteredFolderList(item)" border>
              <el-table-column prop="folderName" label="文件名" align="center"
                               width="380"></el-table-column>
              <el-table-column label="是否上传附件" align="center" width="110px">
                <template #default="scope">
                  <el-tag v-if="scope.row.files && scope.row.files.length > 0"
                          type="success">是
                  </el-tag>
                  <el-tag v-else type="danger">否</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="智能审核结果" align="center" width="120">
                <template #default="scope">
                  <el-button
                      v-if="!scope.row.folderName.includes('会议视频')"
                      @click.stop="toPreviewRules(scope.row)">查看
                  </el-button>
                </template>
              </el-table-column>
              <!--							<el-table-column label="预审驳回原因" align="center" min-width="150" >-->
              <!--								<template #default="scope">-->
              <!--									<el-tooltip class="item" effect="dark" :content="scope.row.aiExamineMessage "-->
              <!--										placement="top">-->
              <!--										<div class="reasonsForRejection" v-if="scope.row.aiAuditStatus != '1'">-->
              <!--											&lt;!&ndash; // {{ scope.row.aiExamineMessage || '-' }} &ndash;&gt;-->
              <!--											<span v-if="!scope.row.aiExamineMessage"> - </span>-->
              <!--											<template v-else>-->
              <!--												<p v-for="(item,i) in scope.row.aiExamineMessage.split('；').filter(item=>item)"-->
              <!--													:key="i" style="text-align: left;">-->
              <!--													<b>{{i+1+`:`}}</b>-->
              <!--													{{item}};-->
              <!--												</p>-->
              <!--											</template>-->
              <!--										</div>-->
              <!--									</el-tooltip>-->
              <!--								</template>-->
              <!--							</el-table-column>-->


              <!--              <el-table-column label="审核结果" align="center" width="120">-->
              <!--                <template #default="scope">-->
              <!--                  <el-tag v-if="scope.row.auditStatus === 1" type="success">-->
              <!--                    通过-->
              <!--                  </el-tag>-->
              <!--                  <el-tag v-else-if="scope.row.auditStatus === 2" type="danger">-->
              <!--                    不通过-->
              <!--                  </el-tag>-->
              <!--                  <el-tag v-else type="warning">-->
              <!--                    待审核-->
              <!--                  </el-tag>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column label="文件驳回原因" align="center" min-width="300">
                <template #default="scope">
                  <!--                  <el-tooltip class="item" effect="dark" :content="scope.row.examineMessage "-->
                  <!--                              placement="top">-->
                  <div style="text-align: left;">

                    <div v-if="scope.row.examineMessage" style="margin-left: 15px; color: #d32f2f;">
                      - 文件夹驳回原因：{{ scope.row.examineMessage }}
                    </div>

                    <div v-for="(file, index) in scope.row.files" :key="index" style="margin-left: 15px;">
                      <div v-if="file.examineMessage" style="color: #d32f2f;">
                        - 【{{ file.fileName }}】：{{ file.examineMessage }}
                      </div>
                    </div>
                  </div>


                  <!--                  </el-tooltip>-->
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200" align="center" fixed="right">
                <template #default="scope">

                  <!-- 先计算当前行的附件整体状态 -->
                  <el-button style="margin-right: 6px" type="text" @click="viewFilesWithFolder(scope.row)">
                    {{ slForm.status === 'OFFICIAL_EXAMINE' ? '去评审附件' : '查看附件' }}
                  </el-button>
                  <span v-if="slForm.status === 'OFFICIAL_EXAMINE'">
                      <i class="el-icon-warning" style="color: #E6A23C; font-size: 16px;"
                         v-if="getAuditStatusIcon(scope.row) == 'pending'"></i>
                      <i class="el-icon-success" style="color: #67C23A; font-size: 16px;"
                         v-else-if="getAuditStatusIcon(scope.row) == 'approved'"></i>
                      <i class="el-icon-error" style="color: #F56C6C; font-size: 16px;"
                         v-else-if="getAuditStatusIcon(scope.row) == 'rejected'"></i>
                      <i class="el-icon-folder-delete" style="color: #67c23a; font-size: 16px;"
                         v-else-if="getAuditStatusIcon(scope.row) == 'empty'"></i>
                  </span>

                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 模块二：  本次结算明细 -->
          <div v-if="item.spendingDetailDtos.length>0" class="basicInformation">
            <h3 v-if="item.spendingDetailDtos.length>0" style="font-weight: bolder">本次结算明细</h3>
            <el-table v-if="item.spendingDetailDtos.length>0" :data="item.spendingDetailDtos" style="width: 100%"
                      show-summary
                      :summary-method="getspendingDetailSummaries" border>
              <!--							<el-table-column label="序号" width="80" type="index" align="center"></el-table-column>-->
              <el-table-column label="费用分类" align="center" width="260px">
                <template #default="scope">
                  <el-select v-model="scope.row.spendingProjectCode" placeholder="请选择收款方式" disabled
                             filterable clearable style="width: 100%;">
                    <el-option v-for="detail in projectTree" :key="detail.id"
                               :label="detail.projectType" :value="detail.id.toString()"/>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="金额(元)" align="center" width="120">
                <template #default="scope">
                  {{ scope.row.money }}
                  <!-- <el-input type="number" v-model.number="scope.row.money" placeholder="仅支持数字及小数点后2位"
                    :min="0" disabled @input="moneyChange(scope.$index, $event, meetingIndex, 'C')">
                    <template #append>元</template>
                  </el-input> -->
                </template>
              </el-table-column>
              <el-table-column label="是否上传附件" align="center" width="110px">
                <template #default="scope">
                  <el-tag v-if="hasUploadedFiles(scope.row)" type="success">是</el-tag>
                  <el-tag v-else type="danger">否</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="智能审核结果" align="center" width="120px">
                <template #default="scope">
                  <el-button
                      v-if="scope.row.detailName.includes('执行人员服务费用')||scope.row.detailName.includes('餐费') "
                      @click.stop="toPreviewRules(scope.row.folderNodeList[0])">查看
                  </el-button>

                  <!--									<el-tag v-if="getAiAuditResult(scope.row.folderNodeList) === 'pass'" type="success"-->
                  <!--										effect="plain">-->
                  <!--										通过-->
                  <!--									</el-tag>-->
                  <!--									<el-tag v-else-if="getAiAuditResult(scope.row.folderNodeList) === 'fail'"-->
                  <!--										type="danger" effect="plain">-->
                  <!--										不通过-->
                  <!--									</el-tag>-->
                  <!--									<el-tag v-else type="warning" effect="plain">-->
                  <!--										待审核-->
                  <!--									</el-tag>-->
                </template>

              </el-table-column>
              <!--							<el-table-column label="智能预审驳回原因" align="center" min-width="150">-->
              <!--								<template #default="scope">-->
              <!--									<div v-if="scope.row.aiAuditStatus != 1" style="text-align: left;">-->
              <!--										<div v-for="folder in scope.row.folderNodeList" :key="folder.id"-->
              <!--											style="margin-bottom: 10px;">-->
              <!--											<div v-if="folder.aiExamineMessage" style="font-weight: bold;">-->
              <!--												【{{ folder.folderName }}】</div>-->
              <!--											<div v-if="folder.aiExamineMessage" style="margin-left: 15px;">-->
              <!--												- 文件夹驳回原因：-->
              <!--												&lt;!&ndash; {{ folder.aiExamineMessage }} &ndash;&gt;-->
              <!--												<span v-if="!folder.aiExamineMessage"> - </span>-->
              <!--												<template v-else>-->
              <!--													<p v-for="(item,i) in folder.aiExamineMessage.split('；').filter(item=>item)"-->
              <!--														:key="i" style="text-align: left;">-->
              <!--														<b>{{i+1+`:`}}</b>-->
              <!--														{{item}};-->
              <!--													</p>-->
              <!--												</template>-->
              <!--											</div>-->
              <!--											<div v-for="(file, index) in folder.files" :key="index"-->
              <!--												style="margin-left: 15px;">-->
              <!--												<div v-if="file.aiExamineMessage">-->
              <!--													- 【{{ file.fileName }}】：{{ file.aiExamineMessage }}-->
              <!--												</div>-->
              <!--											</div>-->
              <!--										</div>-->
              <!--										&lt;!&ndash; 如果整个 folderNodeList 都为空 &ndash;&gt;-->
              <!--										<div v-if="!scope.row.folderNodeList || scope.row.folderNodeList.length === 0">-->
              <!--											暂无驳回原因-->
              <!--										</div>-->
              <!--									</div>-->
              <!--									<div v-else>-->
              <!--										- -->
              <!--									</div>-->
              <!--								</template>-->
              <!--							</el-table-column>-->
              <!--              <el-table-column label="最终审核结果" align="center" width="120px">-->
              <!--                <template #default="scope">-->
              <!--                  <el-tag v-if="getFolderOverallStatus(scope.row.folderNodeList) === 1"-->
              <!--                          type="success">-->
              <!--                    通过-->
              <!--                  </el-tag>-->
              <!--                  <el-tag v-else-if="getFolderOverallStatus(scope.row.folderNodeList) === 2"-->
              <!--                          type="danger">-->
              <!--                    不通过-->
              <!--                  </el-tag>-->
              <!--                  <el-tag v-else type="warning">-->
              <!--                    待审核-->
              <!--                  </el-tag>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column label="费用驳回原因" align="center" min-width="300">
                <template #default="scope">
                  <div style="text-align: left;">
                    <div v-for="folder in scope.row.folderNodeList" :key="folder.id"
                         style="margin-bottom: 10px;">
                      <!--                      <div v-if="folder.examineMessage" style="font-weight: bold;">-->
                      <!--                        【{{ folder.folderName }}】-->
                      <!--                      </div>-->
                      <!--                      <div v-if="folder.examineMessage" style="margin-left: 15px;">-->
                      <!--                        - 文件夹驳回原因：-->
                      <!--                        &lt;!&ndash; {{ folder.examineMessage }} &ndash;&gt;-->
                      <!--                        <span v-if="!folder.examineMessage"> - </span>-->
                      <!--                        <template v-else>-->
                      <!--                          <p v-for="(item,i) in folder.examineMessage.split('；').filter(item=>item)"-->
                      <!--                             :key="i" style="text-align: left;">-->
                      <!--                            <b>{{ i + 1 + `:` }}</b>-->
                      <!--                            {{ item }};-->
                      <!--                          </p>-->
                      <!--                        </template>-->
                      <!--                      </div>-->
                      <div v-for="(file, index) in folder.files" :key="index"
                           style="margin-left: 15px;">
                        <div v-if="file.examineMessage">
                          - 【{{ file.fileName }}】：{{ file.examineMessage }}
                        </div>
                      </div>
                    </div>
                    <!-- 如果整个 folderNodeList 都为空 -->
                    <!--                    <div v-if="!scope.row.folderNodeList || scope.row.folderNodeList.length === 0">-->
                    <!--                      暂无驳回原因-->
                    <!--                    </div>-->
                  </div>

                </template>
              </el-table-column>
              <el-table-column label="操作" width="200" align="center" fixed="right">
                <template #default="scope">
                  <!-- 先计算当前行的附件整体状态 -->
                  <el-button style="margin-right: 6px" type="text" @click="viewFilesWithSpendDetail(scope.row)">
                    {{ slForm.status === 'OFFICIAL_EXAMINE' ? '去评审附件' : '查看附件' }}
                  </el-button>
                  <span v-if="slForm.status === 'OFFICIAL_EXAMINE'">
                  <i class="el-icon-warning" style="color: #E6A23C; font-size: 16px;"
                     v-if="getAuditStatusIcon(scope.row) == 'pending'"></i>
                  <i class="el-icon-success" style="color: #67C23A; font-size: 16px;"
                     v-else-if="getAuditStatusIcon(scope.row) == 'approved'"></i>
                  <i class="el-icon-error" style="color: #F56C6C; font-size: 16px;"
                     v-else-if="getAuditStatusIcon(scope.row) == 'rejected'"></i>
                  <i class="el-icon-folder-delete" style="color: #67c23a; font-size: 16px;"
                     v-else-if="getAuditStatusIcon(scope.row) == 'empty'"></i>
                  </span>

                </template>
              </el-table-column>
            </el-table>

            <!-- <div class="subtotal">
              <el-button type="text"
                v-if="slForm.status === 'WAIT' || slForm.status === 'ERROR' || !slForm.id"
                @click="addRows(meetingIndex, 'C')">新增行
              </el-button>
            </div>
            <div class="subtotal">合计本次结算金额：{{ calculateTotal(item) }}元</div> -->

          </div>
        </div>
      </el-main>
    </el-container>


    <div class="auditLog">
      <h3 style="font-weight: bolder">审核日志</h3>

      <audit-log-table :audit-logs="logList" />

    </div>

    <div class="formOptions" v-if="slForm.status=='OFFICIAL_EXAMINE'">
      <el-button type="primary" @click="openAuditDialog('SUCCESS')">审核通过</el-button>
      <el-button type="danger" @click="openAuditDialog('ERROR')">审核退回</el-button>
    </div>

    <div class="formOptions" v-if=" slForm.status=='REJECTED' ">
      <el-button type="primary" @click="openAuditDialog('SUCCESS')">重提金蝶</el-button>
      <el-button type="danger" @click="openAuditDialog('ERROR')">驳回供应商</el-button>
    </div>


    <!-- PDF等文件预览弹窗 -->
    <file-preview :visible.sync="showPreview" :url="previewUrl"/>

    <!-- 文件标注弹窗 -->
    <el-dialog custom-class="annotationDialog" :title="'标注文件 - ' + currentFileToAnnotate.fileName"
               :visible.sync="fileAnnotateDialogVisible">
      <el-input type="textarea" :rows="4" placeholder="请输入文件标注内容" v-model="fileAnnotationText"></el-input>
      <span slot="footer" class="dialog-footer">
				<el-button @click="fileAnnotateDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveFileAnnotation">保存标注</el-button>
			</span>
    </el-dialog>

    <!-- 标注弹窗 -->
    <el-dialog custom-class="annotationDialog" :title="'标注 - ' + currentAnnotateMaterial.folderName"
               :visible.sync="annotateDialogVisible" width="60%">
      <el-input type="textarea" :rows="4" placeholder="请输入标注内容" v-model="annotationText"></el-input>
      <span slot="footer" class="dialog-footer">
				<el-button @click="annotateDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="saveAnnotation">保存标注</el-button>
			</span>
    </el-dialog>

    <!-- 通用审核弹窗 -->
    <el-dialog custom-class="reviewDialog" :title="this.dialogType === 'SUCCESS' ? '审核通过确认' : '审核退回'"
               :visible.sync="auditDialogVisible" width="500px" append-to-body :close-on-click-modal="false">
      <div class="form">
        <h2 v-if="dialogType != 'ERROR'">提交事由：</h2>
        <div v-if="dialogType != 'ERROR'" class="tips">提交事由将会在金蝶中的事由字段中做展示</div>
        <el-form :model="auditForm" ref="auditForm" :rules="auditRules">
          <!-- 动态显示不同字段 -->
          <el-form-item v-if="dialogType === 'SUCCESS'" label="审核备注" prop="remark">
            <el-input maxlength="100" show-word-limit type="textarea" :rows="4" placeholder="请输入审核备注"
                      v-model="auditForm.remark"></el-input>
          </el-form-item>
          <el-form-item v-if="dialogType === 'ERROR'" label="退回原因" prop="errorMessage">
            <el-input maxlength="100" show-word-limit type="textarea" :rows="4" placeholder="请输入退回原因"
                      v-model="auditForm.errorMessage"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button @click="auditDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmAudit">确 定</el-button>
			</span>
    </el-dialog>

    <SignCheckDialog ref="signCheckDialog"></SignCheckDialog>


    <!-- 弹窗 -->
    <el-dialog
        title="审核规则详情"
        :visible.sync="dialogVisible"
        width="90%"
        :close-on-click-modal="false"
        @closed="onDialogClosed"
    >
      <!-- 使用子组件 -->
      <AuditTable
          ref="auditTable"
          :folderId="currentFolder.id"
          @cancel="dialogVisible = false"
          @confirm="handleConfirm"
          @view="handleView"
          @edit="handleEdit"
      />
    </el-dialog>


    <el-dialog v-loading="editLoading" :close-on-click-modal="false" title="修改费用申请单号"
               :visible.sync="updDialogVisible" width="600px" @close="handleClose">
      <el-form :model="updForm" label-width="140px" :rules="updRules" ref="form">

        <el-form-item label="社组账号" prop="username">
          <el-input placeholder="请输入您的社组采购系统管理端账号" v-model="updForm.username"></el-input>
        </el-form-item>
        <el-form-item label="社组密码" prop="password">
          <el-input placeholder="请输入您的社组采购系统管理端密码" v-model="updForm.password" show-password></el-input>
        </el-form-item>
        <el-form-item label="费用申请单号" prop="applyNo">
          <el-input v-model="updForm.applyNo" placeholder="请输入申请单号"/>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="updDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import {
  allSpendFolderListOfOfficial,
  annotateFile,
  annotateFolder,
  downloadDetailFolderBYOfficial,
  downloadProjectFiles,
  examineSpendingOrder,
  getOrderByIdWithOfficial,
  getOrderMeetingListByOrderId,
  listOrderLog,
  updateApplyNo,
  officialGetExpenseItem,
  queryFile, redirctUrl
} from '@/request/api'
import FilePreview from '@/components/FilePreview.vue';
import SignCheckDialog from '@/components/SignCheckDialog/SignCheckDialog.vue'
import AuditTable from "@/components/AuditTable/AuditTable.vue";
import AuditLogTable from "@/components/AuditLogTable/AuditLogTable.vue";

export default {
  name: 'newindex',
  components: {
    AuditLogTable,
    FilePreview, SignCheckDialog, AuditTable
  },

  computed: {
    // 处理后的会议列表，包含 lastDetailDtos 和 spendingDetailDtos
    processedMeetingList() {
      return this.processMeetingList(this.meetingWithDetailsList);
    },
    selectedMeetings() {
      const map = new Map(this.meetingList.map(m => [Number(m.id), m]));
      return (this.slForm.meetingIds || []).map(id => map.get(Number(id))).filter(Boolean);
    }
  },

  data() {
    return {
      editLoading: false,
      updDialogVisible: false, // 控制弹窗显示
      updForm: {
        applyNo: '' // 默认值
      },
      updRules: {
        username: [
          {required: true, message: '请输入您的社组采购系统管理端账号', trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入您的社组采购系统管理端密码', trigger: 'blur'}
        ]
      },


      serviceReviewUrl: 'https://kmis.cpaa.org.cn/purchase/supplier-service-review',
      currentFolder: {},
      dialogVisible: false,
      meetingWithDetailsList: [], //会议下的全部支出明细
      loading: false,
      //审核日志
      logList: [],
      expenseItem: [],
      slForm: {
        collectWay: '', // 收款方式
        feeType: '', // 费用类型
        projectName: '', // 项目名称
        supplierName: '', // 供应商名称
        applyMoney: 0, // 本次收款金额
        receiptType: '', // 发票类型
        deliveryNum: '', // 快递单号
        spendingDetailDtos: [{
          detailType: "",
          id: "",
          spendingProjectCode: "UM000",
          money: ''
        }], //
        feeTypeNo: '',
        projectNo: ''
      },
      feeTypeEnums: [{
        value: "0",
        label: "会议类"
      },
        {
          value: '1',
          label: "非会议类"
        }
      ],
      receiptTypeEnums: [{
        value: "0",
        label: "电子发票"
      }, {
        value: "1",
        label: "纸质发票"
      },
        {
          value: "2",
          label: "电子+纸质发票"
        }
      ],

      collectWayList: {
        "0": "一次性收款并结项",
        "1": "首次收款",
        "2": "阶段收款",
        "3": "尾款",
        "4": "据实结算",
      },

      collectWayEnums: [{
        value: "0",
        label: "一次性收款并结项"
      }, {
        value: "1",
        label: "首次收款"
      }, {
        value: "2",
        label: "阶段收款"
      }, {
        value: "3",
        label: "尾款"
      }, {
        value: "4",
        label: "据实结算"
      }],
      auditForm: {
        remark: '', // 审核通过备注
        errorMessage: '' // 审核退回原因
      },
      auditDialogVisible: false, // 控制弹窗显示
      dialogType: '', // 操作类型：SUCCESS/ERROR
      // 表单验证规则
      auditRules: {
        remark: [{
          required: true,
          message: '请输入备注',
          trigger: 'blur'
        },
          {
            min: 1,
            message: '备注不能少于1个字符',
            trigger: 'blur'
          }
        ],
        errorMessage: [{
          required: true,
          message: '请输入退回原因',
          trigger: 'blur'
        },
          {
            min: 1,
            message: '原因不能少于1个字符',
            trigger: 'blur'
          }
        ]
      },
      projectTree: [],
      meetingList: [],
      hoveredFile: null, // 当前悬停的文件
      // folderList: [],
      // materials: folderData.children,
      showPreview: false,
      previewUrl: '',
      isPdfPreview: false,
      isImagePreview: false,
      currentFile: null,
      currentFileToAnnotate: {
        fileName: ''
      }, // 要标注的文件
      annotateDialogVisible: false,
      fileAnnotateDialogVisible: false, // 文件标注弹窗
      annotationText: '',
      fileAnnotationText: '', // 文件标注内容
      currentAnnotateMaterial: {
        folderName: ''
      },
      spendId: this.$route.query.id,
      rules: {
        collectWay: [{
          required: true,
          message: '请选择收款方式',
          trigger: 'change'
        }],
        feeType: [{
          required: true,
          message: '请选择费用类型',
          trigger: 'change'
        }],
        projectName: [{
          required: true,
          message: '请输入项目名称',
          trigger: 'change'
        }],
        supplierName: [{
          required: true,
          message: '请输入供应商名称',
          trigger: 'change'
        }],
        applyMoney: [{
          required: true,
          message: '请完善本次收款明细',
          trigger: 'change'
        }],
        lastUsedMoney: [{
          required: true,
          message: '请完善上阶段支出明细',
          trigger: 'change'
        }],
        receiptType: [{
          required: true,
          message: '请选择发票类型',
          trigger: 'change'
        }],
        deliveryNum: [{
          required: false,
          message: '请输入快递单号',
          trigger: 'blur'
        }],
        meetingIds: [{
          required: true,
          message: '请选择您要结算的会议场次',
          trigger: 'change'
        }],
        projectNo: [{
          required: true,
          message: '请输入金蝶项目编号',
          trigger: 'change'
        }],
        feeTypeNo: [{
          required: true,
          message: '请选择金蝶项目类型',
          trigger: 'change'
        }]
      },
    }
  },
  mounted() {
    this.orderId = this.$route.query.orderId
    this.getParams();
    this.getExpenseItemFun();
    this.loadData();
    this.loadLog();
  },
  methods: {

    // 打开弹窗（可由父组件调用）
    openDialog(applyNo) {
      this.updForm.applyNo = applyNo
      this.updDialogVisible = true;
    },


    // 关闭弹窗（可做重置）
    handleClose() {
      this.$refs.form.resetFields(); // 清空验证
      this.updDialogVisible = false;
    },

    // 提交处理
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.editLoading = true
          this.updForm.orderId = this.orderId;
          updateApplyNo(this.updForm).then(res => {
            if (res.code == 200) {
              this.$set(this.slForm, 'applicationForm', this.updForm.applyNo);
              this.handleClose()
              this.$message({
                message: '操作成功',
                type: 'success'
              });

            } else {
              this.$message({
                message: res.msg,
                type: 'error'
              });
            }

          }).finally(() => {
            this.editLoading = false
          })
        } else {
          console.log('验证失败');
        }
      });
    },


    openServiceReview(supplierName, bibProjectName) {
      const baseUrl = this.serviceReviewUrl;
      if (!baseUrl) {
        console.error('服务评审URL未在环境变量中配置');
        return;
      }

      if (!supplierName || !bibProjectName) {
        console.error('缺少必要参数：supplierName 或 bibProjectName');
        return;
      }

      // 使用 URLSearchParams 自动处理中文编码
      const params = new URLSearchParams({
        supplierName,
        bibProjectName
      });

      const fullUrl = `${baseUrl}?${params.toString()}`;
      window.open(fullUrl, '_blank');
    },


    handleDownloadAll() {
      this.$confirm('是否下载结算单全部文件？文件较大，下载可能需要较长时间。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 用户点击“确定”，执行下载逻辑
        this.downloadProjectFiles();
      }).catch(() => {
        // 用户点击“取消”或关闭弹窗，不执行操作
        this.$message.info('已取消下载');
      });
    },

    // 示例：你的下载方法（根据你的实际逻辑调整）
    async downloadProjectFiles() {
      try {
        let data = {
          orderId: this.$route.query.orderId
        };
        this.loading = true;
        this.$message({
          message: '正在下载，请稍后...',
          type: 'warning'
        });
        downloadProjectFiles(data).then(res => {
          let blob = new Blob([res], {
            type: 'application/zip'
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.target = '_blank';
          a.style.display = 'none';
          a.href = url;
          a.download = this.slForm.projectName + ".zip";
          a.click();
          window.URL.revokeObjectURL(url);
          this.loading = false;
        })

      } catch (error) {
        this.$message.error('下载失败，请稍后重试');
      }
    },


    // 批量下载
    async bulkDownload(detailId, detailName) {
      try {
        await this.$confirm('是否下载"线下线上-必须要的材料"下全部文件？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        this.loading = true;
        this.$message({
          message: '正在下载，请稍后...',
          type: 'warning'
        });
        downloadDetailFolderBYOfficial({detailId: detailId}).then(res => {
          const filename = `${detailName}.zip`;
          let blob = new Blob([res], {
            type: 'application/zip'
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.target = '_blank';
          a.style.display = 'none';
          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
          this.loading = false;
        })
      } catch (error) {
        //  关键：只处理非“取消”的错误
        if (error !== 'cancel') {
          this.$message.error('操作失败，请稍后重试');
          console.error('Download error:', error);
        }
        // 如果是 'cancel'，静默忽略，不报错
      }
    },


    handleConfirm(remarks) {
      console.log('用户填写的备注：', remarks);
      // 执行确认逻辑，如提交审核
      this.$message.success('审核意见已提交');
      this.dialogVisible = false;
    }
    ,
    handleView(row) {

      this.$refs.signCheckDialog.dialogVisible = true;

      // this.$alert(`查看规则详情：<br><strong>${row.ruleName}</strong><br>${row.auditDetails}`, '规则详情', {
      //     dangerouslyUseHTMLString: true,
      //     type: 'info'
      // });
    }
    ,
    handleEdit(row) {
      console.log("返回，", row)
      this.$refs.signCheckDialog.open(row); // 传入 data 数组中的某一项

    }
    ,
    onDialogClosed() {
      // 关闭时重置备注
      this.$refs.auditTable?.reset?.();

    }
    ,

    toPreviewRules(folderObj) {
      // this.$refs.signCheckDialog.dialogVisible = true;

      console.log(folderObj);
      this.currentFolder = folderObj;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.auditTable.fetchAuditData();
      })
    }
    ,


    // 判断整行附件的综合审核状态
    getAuditStatusIcon(input) {
      // 判断输入类型并标准化为 folders 数组
      let folders = [];

      if (input && typeof input === 'object' && !Array.isArray(input)) {
        // 单个 folder 对象（有 files）
        if (input.files && Array.isArray(input.files)) {
          folders = [input];
        }
        // row 对象（有 folderNodeList）
        else if (input.folderNodeList && Array.isArray(input.folderNodeList)) {
          folders = input.folderNodeList;
        }
        // 其他对象：视为无数据
        else {
          folders = [];
        }
      } else if (Array.isArray(input)) {
        // 直接是 folder 数组
        folders = input;
      } else {
        // 无效输入
        folders = [];
      }

      // 检查是否“整体为空”：所有 folder 的 files 都为空
      const hasAnyFile = folders.some(folder =>
          folder && folder.files && Array.isArray(folder.files) && folder.files.length > 0
      );

      if (!hasAnyFile) {
        return 'empty'; // 所有文件夹都无文件 → 显示空文件夹图标
      }

      // 收集所有 auditStatus
      const allStatuses = [];
      for (const folder of folders) {
        if (folder && folder.files && Array.isArray(folder.files)) {
          for (const file of folder.files) {
            if (file.auditStatus != null) {
              allStatuses.push(file.auditStatus);
            }
          }
        }
      }

      // 审核状态判断（优先级）
      if (allStatuses.some(status => status === 0)) {
        return 'pending';
      }
      if (allStatuses.some(status => [2, 6, 8].includes(status))) {
        return 'rejected';
      }
      return 'approved';
    },


    getAiAuditResult(folderList) {
      if (!Array.isArray(folderList) || folderList.length === 0) {
        return '待审核'; // 如果没有数据，默认为待审核
      }

      const hasFail = folderList.some(item => item.aiAuditStatus == 2);
      const allPass = folderList.every(item => item.aiAuditStatus == 1);

      if (hasFail) {
        return 'fail'; // 存在不通过
      } else if (allPass) {
        return 'pass'; // 全部通过
      } else {
        return 'pending'; // 其他情况：待审核（如部分为0或未处理）
      }
    }
    ,


    getFolderOverallStatus(folderNodeList) {
      if (!folderNodeList || !Array.isArray(folderNodeList)) {
        return 0;
      }

      let hasPending = false;   // 存在待审核文件
      let hasRejected = false;  // 存在驳回文件
      let hasAnyValidFile = false; // 是否存在需要审核的文件

      for (const folder of folderNodeList) {
        const isRequired = folder.ifFileRequired === 'Y';
        const hasFiles = folder.files && folder.files.length > 0;

        // 判断是否需要参与审核
        if (!hasFiles && !isRequired) {
          // 非必填且无文件 → 跳过
          continue;
        }

        // 只要进入这里，说明这个文件夹的文件需要被审核
        if (hasFiles) {
          hasAnyValidFile = true;

          for (const file of folder.files) {
            const status = file.auditStatus;
            const normalized = (status == null) ? '' : String(status).trim();

            if (normalized === '1') {
              // 通过，无操作
            } else if (normalized === '2') {
              hasRejected = true;
            } else {
              // 包括 0, "", null, undefined, "0" 等 → 待审核
              hasPending = true;
            }
          }
        } else if (isRequired) {
          // 必填但无文件 → 应视为“待审核”或“不完整”
          hasPending = true;
          hasAnyValidFile = true;
        }
      }

      // 如果没有任何有效文件（比如全是非必填且空），按业务可返回 0 或特殊处理
      if (!hasAnyValidFile) {
        return 0; // 或根据需求返回其他值
      }

      if (hasPending) {
        return 0; // 待审核优先
      } else if (hasRejected) {
        return 2; // 不通过
      } else {
        return 1; // 全部通过
      }
    }
    ,


    // getFolderOverallStatus(folderNodeList) {
    //   console.log("121",folderNodeList)
    // 	if (!folderNodeList || folderNodeList.length === 0) {
    // 		return 0; // 没有文件夹，默认待审核
    // 	}
    //
    // 	let allPassed = true;
    // 	let hasRejected = false;
    //
    // 	for (const folder of folderNodeList) {
    // 		// 判断是否有文件（files 不为空）
    // 		const hasFiles = folder.files && folder.files.length > 0;
    //
    // 		// 只有当该文件夹有文件时才参与状态判断
    // 		if (hasFiles) {
    // 			if (folder.auditStatus === 2) {
    // 				hasRejected = true;
    // 				break;
    // 			} else if (folder.auditStatus !== 1) {
    // 				allPassed = false;
    // 			}
    // 		} else {
    // 			// 如果文件夹没有文件，也视为未完成审核（待审核）
    // 			allPassed = false;
    // 		}
    // 	}
    //
    // 	if (hasRejected) {
    // 		return 2; // 有驳回项
    // 	} else if (allPassed) {
    // 		return 1; // 全部通过
    // 	} else {
    // 		return 0; // 有文件夹未审核或无文件
    // 	}
    // },
    toggleReason(row) {
      this.$set(row, '_showReason', !row._showReason);
    }
    ,
    hasUploadedFiles(row) {
      if (!row.folderNodeList || !Array.isArray(row.folderNodeList)) return false;
      return row.folderNodeList.some(folder => folder.files && folder.files.length > 0);
    }
    ,
    getspendingDetailSummaries(param) {
      const {
        columns,
        data
      } = param;
      const sums = [];

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '金额合计(元)';
          return;
        }

        const moneyColumnIndex = 2; // 金额列在第3列（索引从0开始）

        if (index === moneyColumnIndex) {
          const values = data.map(item => Number(item.money));
          const total = values.reduce((prev, curr) => {
            const value = isNaN(curr) ? 0 : curr;
            return prev + value;
          }, 0);

          sums[index] = `￥${total.toFixed(2)} 元`;
        } else {
          sums[index] = '';
        }
      });

      return sums;
    }
    ,

    // 处理会议列表，分离上次结算和本次结算
    processMeetingList(meetingList) {
      return meetingList.map(meeting => {
        // let lastDetailDtos = [];
        const spendingDetailDtos = [];

        if (Array.isArray(meeting.details)) {

          const EXCLUDED_CODES = new Set(['1', '41', '39']);


          meeting.details.forEach(detail => {
             if (detail.detailType === 'C' && !EXCLUDED_CODES.has(detail.spendingProjectCode)) {
              spendingDetailDtos.push(detail);
            }
          });
        }


        // ✅ 排序：按 spendingProjectCode 数值升序
        const numericSort = (a, b) => {
          const numA = parseInt(a.spendingProjectCode) || 0;
          const numB = parseInt(b.spendingProjectCode) || 0;
          return numA - numB; // 升序
        };

        // lastDetailDtos.sort(numericSort);
        spendingDetailDtos.sort(numericSort);

        return {
          ...meeting,
          // lastDetailDtos,
          spendingDetailDtos
        };
      });
    }
    ,
    // 获取每个会议中 spendingProjectCode == "1" 的 folderNodeList
    filteredFolderList(meeting) {
      const result = [];
      meeting.details?.forEach(detail => {
        if (detail.spendingProjectCode === "1" || detail.spendingProjectCode === "41"||  detail.spendingProjectCode === "39"  ) {
          result.push(...detail.folderNodeList);
        }
      });
      return result;
    }
    ,
    // 合计金额
    calculateTotal(meeting) {
      return meeting.spendingDetailDtos.reduce((sum, detail) => sum + (parseFloat(detail.money) || 0), 0)
          .toFixed(2);
    }
    ,
    // 金额输入事件
    moneyChange(index, value, meetingIndex, type) {
      // 你的金额处理逻辑
    }
    ,
    // 删除行
    deleteNewRows(index, meetingIndex, type) {
      this.processedMeetingList[meetingIndex].spendingDetailDtos.splice(index, 1);
    }
    ,
    // 新增行
    addRows(meetingIndex, type) {
      this.processedMeetingList[meetingIndex].spendingDetailDtos.push({
        spendingProjectCode: '',
        money: ''
      });
    }
    ,
    // 支出明细-去查看附件
    viewFilesWithSpendDetail(row) {
      console.log('查看文件夹:', row);
      // 示例：this.$router.push(`/upload/${row.id}`);
      this.$router.push({
        name: 'viewDetail',
        query: {
          orderId: row.supplierApplyCollectId,
          selectedDetailId: row.id,
          selectedMeetingId: row.meetingId
        }
      });
    }
    ,

    // 必传材料-去查看附件
    viewFilesWithFolder(row) {
      console.log('查看文件夹:', row);
      this.$router.push({
        name: 'viewDetail',
        query: {
          orderId: row.applyCollectId,
          selectedDetailId: row.spendingDetailId,
          selectedMeetingId: row.meetingId,
          selectFolderId: row.id
        }
      });
    }
    ,


    //查询审核日志
    loadLog() {
      listOrderLog({
        orderId: this.$route.query.orderId
      }).then(res => {
        if (res.code == 200) {
          // this.logList = res.data;
          this.logList = res.data
              .map(item => {
                let rejectedFiles = [];
                try {
                  // 如果 remark 存在且是字符串，尝试 JSON.parse
                  if (typeof item.remark === 'string' && item.remark.trim()) {
                    const parsed = JSON.parse(item.remark);
                    // 确保解析结果是数组
                    if (Array.isArray(parsed)) {
                      rejectedFiles = parsed;
                    }
                  }
                  // 如果 remark 本身就是对象数组（某些情况），也可以兼容
                  else if (Array.isArray(item.remark)) {
                    rejectedFiles = item.remark;
                  }
                } catch (e) {
                  console.warn('解析 remark 失败:', item.remark, e);
                  rejectedFiles = []; // 解析失败则置空
                }

                // 返回新对象，添加 rejectedFiles 字段（不污染原始数据）
                return {
                  ...item,
                  rejectedFiles // 新增字段，供表格使用
                };
              });



        }
      })
    }
    ,
    formatStatus(item) {
      const {status, operatorId} = item;

      // 按照模板中的优先级依次判断
      if (status === 'OFFICIAL_EXAMINE') {
        return '待审核';
      }
      if (status === 'SUCCESS') {
        return '复审通过';
      }
      if (status === 'SUBMIT') {
        return '财务审核中';
      }
      if (status === 'REJECTED') {
        return '金蝶驳回';
      }
      if (status === 'AI_REVIEW_SUCCESS') {
        return 'AI预审中';
      }
      if (status === 'FINISH') {
        return '已打款';
      }
      if (status === 'ERROR') {
        // 注意：模板中显示的是“被驳回”，不是“初审驳回”或“复审驳回”
        // 虽然原方法有 operatorId == '0' 判断，但模板里没区分，统一显示“被驳回”
        return '被驳回';
      }

      // 兜底
      return status || '未知状态';
    }
    ,
    // 确认审核操作
    confirmAudit() {
      this.$refs.auditForm.validate(valid => {
        if (valid) {
          this.examineSpendingOrder();
          this.auditDialogVisible = false;
        }
      });
    }
    ,
    examineSpendingOrder() {
      console.log('备注：', this.auditForm.remark);
      console.log('审核退回，原因：', this.auditForm.errorMessage);
      this.loadingText = '正在提交···'
      this.loading = true;
      examineSpendingOrder({
        orderId: this.slForm.id,
        status: this.dialogType,
        remark: this.auditForm.remark,
        errorMessage: this.auditForm.errorMessage
      }).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
          this.getSheetDataFun();
          this.loadLog()
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          });
        }
      })
    }
    ,
    getExpenseItemFun(itemName) {
      let data = {}
      data.current = 1;
      data.size = 3000;
      if (itemName) data.itemName = itemName
      officialGetExpenseItem(data).then(res => {
        if (res.code == 200) {
          this.expenseItem = res.data.data
        }
      })
    }
    ,
    getParams() {
      this.getSheetDataFun();
      this.getProjectConfigFun();
      // 获取当前用户token
      // this.token = localStorage.getItem('regToken') ? JSON.parse(localStorage.getItem('regToken')).token : JSON
      //     .parse(localStorage.getItem('token')).token;
    }
    ,
    // 获取结算单信息
    getSheetDataFun() {
      getOrderByIdWithOfficial({
        orderId: this.$route.query.orderId
      }).then(res => {
        if (res.code == 200) {
          let resData = JSON.parse(JSON.stringify(res.data));
          for (let i in resData) {
            if (resData[i] == null) resData[i] = '';
          }

          if (resData.collectWay == 2 || resData.collectWay == 3) {
            resData.lastDetailDtos = [];
            if (resData.selectMeetingList.length > 0) {
              resData.lastDetailDtos = resData.selectMeetingList[0].lastDetailDtos;
            }
          }

          if (resData.meetingIds) {
            // resData.meetingIds
            // console.log(resData.meetingIds);
          } else {
            resData.meetingIds = [];
          }
          // console.log(resData);
          this.slForm = resData;
          this.meetingList = resData.meetingList || [];

          this.getMeetingList();
        }
      });
    }
    ,
    // 获取会议列表
    getMeetingList() {
      let data = {
        orderId: this.orderId
      };
      // orderMeetingListBOfficial(data).then(res => {
      //   if (res.code == 200) this.meetingList = res.data;
      // });
      getOrderMeetingListByOrderId(data).then(res => {
        if (res.code == 200) this.meetingList = res.data;
      });
    }
    ,
    // 获取支出明细类型列表
    getProjectConfigFun() {
      allSpendFolderListOfOfficial().then(res => {
        if (res.code == 200) {
          this.projectTree = res.data
        }
      })
    }
    ,
    loadData() {
      queryFile({
        id: this.$route.query.orderId
      }).then((res) => {
        // console.log(res)
        if (res.code == 200) {
          // this.folderList = res.data;
          this.meetingWithDetailsList = res.data

        }
      })
    }
    ,
    // 打开审核弹窗
    openAuditDialog(type) {
      this.dialogType = type;
      this.auditDialogVisible = true;
      this.resetForm();
      if (type === 'SUCCESS') {
        this.auditForm.remark =
            `会议合规管理-【供应商结算】${this.slForm.projectName}-${this.collectWayList[this.slForm.collectWay]}`;
      }
    }
    ,

    // //跳转到金蝶
    // toJdCloud(orderId){
    //   redirctUrl({orderId: orderId}).then(res=>{
    //     if(res.code==200){
    //       window.open(res.data);
    //     }else {
    //       this.$message.error(res.msg);
    //     }
    //   })
    // },


    // 重置表单
    resetForm() {
      this.auditForm = {
        remark: '',
        errorMessage: ''
      };
      if (this.$refs.auditForm) {
        this.$refs.auditForm.resetFields();
      }
    }
    ,
    // 打开文件标注对话框
    annotateFile(file) {
      this.currentFileToAnnotate = file;
      this.fileAnnotationText = file.examineMessage || '';
      this.fileAnnotateDialogVisible = true;
    }
    ,
    // 判断文件是否为PDF
    isPdf(fileName) {
      return fileName.toLowerCase().endsWith('.pdf');
    }
    ,
    // 判断文件是否为图片
    isImage(fileName) {
      const imgExts = ['.jpg', '.jpeg', '.png', '.gif', '.bmp'];
      return imgExts.some(ext => fileName.toLowerCase().endsWith(ext));
    }
    ,
    isWord(filename) {
      return /\.(doc|docx)$/i.test(filename);
    }
    ,
    isExcel(filename) {
      return /\.(xls|xlsx)$/i.test(filename);
    }
    ,
    isPPT(filename) {
      return /\.(ppt|pptx)$/i.test(filename);
    }
    ,
    // 获取短文件名（防止文件名过长）
    getShortFileName(fileName) {
      if (fileName.length > 15) {
        return fileName.substring(0, 8) + '...' + fileName.slice(-7);
      }
      return fileName;
    }
    ,
    // 预览单个文件
    previewFile(file) {
      console.log(file)
      this.currentFile = file;
      this.previewUrl = file.ossUrl;
      this.showPreview = true;
    }
    ,
    // 预览整个文件夹
    previewFiles(material) {
      if (material.files.length > 0) {
        this.previewFile(material.files[0]);
      } else {
        this.$message.warning('此材料项下暂无文件可预览');
      }
    }
    ,
    // 关闭预览
    closePreview() {
      this.showPreview = false;
      this.previewUrl = '';
    }
    ,
    // 下载文件
    downloadFile() {
      if (this.currentFile) {
        window.open(this.currentFile.ossUrl, '_blank');
      }
    }
    ,
    // 打开标注对话框
    annotate(material) {
      this.currentAnnotateMaterial = material;
      this.annotationText = ''; // 清空之前的标注
      this.annotateDialogVisible = true;
    }
    ,
    //文件夹审核通过
    apply(material) {
      //文件夹整体审核通过
      annotateFolder({
        folderId: material.id,
        auditStatus: 1 //1审核通过 2审核驳回
      }).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.$message.success('标注已保存');
          this.loadData()
        }
      })
    }
    ,
    // 保存标注
    saveAnnotation() {
      if (!this.annotationText.trim()) {
        this.$message.warning('请先输入标注内容');
        return;
      }
      annotateFolder({
        folderId: this.currentAnnotateMaterial.id,
        annotation: this.annotationText,
        auditStatus: 2 //1审核通过 2审核驳回
      }).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.$message.success('标注已保存');
          this.annotateDialogVisible = false;
          this.loadData()
        }
      })
    }
    ,
    // 保存文件标注
    saveFileAnnotation() {
      if (!this.fileAnnotationText.trim()) {
        this.$message.warning('请先输入文件标注内容');
        return;
      }
      annotateFile({
        fileId: this.currentFileToAnnotate.id,
        annotation: this.fileAnnotationText,
        auditStatus: 2 //1审核通过 2审核驳回
      }).then(res => {
        console.log(res)
        if (res.code == 200) {
          this.$message.success('文件标注已保存');
          this.fileAnnotateDialogVisible = false;
          this.loadData()
        } else {
          this.$message.warn(res.msg);
        }
      })
    }
    ,
    // 模拟上传文件
    uploadFile(material) {
      this.$message.info('文件上传功能已触发，实际项目中调用上传API');
    }
    ,
    // 显示详情
    showMaterialDetails(material) {
      this.$message({
        message: `${material.folderName} 的详细信息`,
        customClass: 'custom-message',
        duration: 2000,
        iconClass: 'el-icon-info'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  background-color: #f5f7fa;
}

//.app-container {
//	//max-width: 1200px;
//	margin: 20px auto;
//	padding: 0 20px;
//}


.material-list {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  overflow: hidden;
}

.material-item {
  border-bottom: 1px solid #eaeef5;
  padding: 20px;
  transition: background-color .3s;
}

.material-item:last-child {
  border-bottom: none;
}

.material-item:hover {
  background-color: #f9fbfd;
}

.material-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
}

.material-title {
  font-weight: 500;
  font-size: 16px;
  color: #1f2d3d;
}

.material-status {
  display: flex;
  align-items: center;
  gap: 15px;
}

.status-badge {
  padding: 4px 10px;
  font-size: 12px;
  border-radius: 12px;
  background-color: #ecf5ff;
  color: #67c23a;
  border: 1px solid #e1f3d8;
}

.status-badge.orange {
  background-color: #fdf6ec;
  color: #e6a23c;
  border-color: #faecd8;
}

.status-badge.red {
  background-color: #fdf6ec;
  color: red;
  border-color: #faecd8;
}

.file-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 15px;
  margin-top: 15px;
}

.file-item {
  position: relative;
  width: 100px;
  //height: 100px;
  //border: 1px dashed #dcdfe6;
  //border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color .3s;

  .file-preview {
    position: relative;
    background-color: #fff;
    width: 100%;
    width: 100%;
    //height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    overflow: hidden;

    .file-icon {
      width: 100px;
      height: 100px;
      object-fit: contain;
      /* 可选：保持图片比例 */
    }
  }
}

.file-item:hover {
  border-color: #409eff;
}

//.file-preview {
//  width: 60px;
//  height: 60px;
//  display: flex;
//  align-items: center;
//  justify-content: center;
//  font-size: 40px;
//  color: #909399;
//}


/* 文件右上角提示符号 */
.file-warning-icon {
  position: absolute;
  top: 4px;
  right: 4px;
  // width: 20px;
  // height: 20px;
  // background: #E6A23C;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  i {
    font-size: 17px;
    font-weight: bold;
    color: #E6A23C;
  }
}

/* 文件悬浮遮罩层 */
.file-hover-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  z-index: 1;

  .mask-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .mask-button {
    margin: 4px 0;
    width: 80px;
    background: rgba(255, 255, 255, 0.8);
    border: none;

    &:hover {
      background: white;
    }
  }
}

.file-name {
  //width: 100%;
  //padding: 0 5px;
  //font-size: 12px;
  //color: #606266;
  //text-align: center;
  //overflow: hidden;
  //text-overflow: ellipsis;
  //white-space: nowrap;
  margin-top: 8px;
  text-align: center;
  font-size: 12px;
  color: #606266;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.action-panel {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 10px;
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  height: 100%;
}

.upload-placeholder i {
  font-size: 28px;
  margin-bottom: 5px;
}

.icon-pdf {
  color: #f56c6c;
}

.icon-image {
  color: #67c23a;
}

.icon-other {
  color: #909399;
}

.pdf-viewer-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .8);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pdf-viewer {
  width: 80%;
  height: 90%;
}

.close-preview {
  position: absolute;
  top: 20px;
  right: 20px;
  font-size: 24px;
  color: white;
  cursor: pointer;
}

.formOptions {
  margin: 20px;
  display: flex;
  justify-content: center;
}

.noFile {
  width: 100px;
  height: 80px;
  //margin: 0 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0 2px 18px rgba(190, 190, 190, 0.31);
  border-radius: 10px;
  padding: 10px;
  color: #ccc;
  font-size: 16px;
  margin-bottom: 10px;

  i {
    font-size: 30px;
  }
}

.auditLog {
  margin: 20px;
  padding: 20px;
  box-shadow: 0 2px 18px rgba(190, 190, 190, 0.31);
  border-radius: 4px;

  h3 {
    margin-bottom: 20px;
  }
}

.basicInformation {
  //margin: 20px 0px;
  padding: 20px;
  box-shadow: 0 2px 18px rgba(190, 190, 190, 0.31);
  border-radius: 4px;
  margin-bottom: 7px;

  h1 {
    margin-bottom: 20px;
    font-size: 20px;
  }

  h3 {
    margin-top: 10px;
    margin-bottom: 10px;
    //font-size: 20px;
  }

  // .reasonsForRejection {

  // 	// 超出5行后显示省略号
  // 	display: -webkit-box;
  // 	-webkit-line-clamp: 5;
  // 	-webkit-box-orient: vertical;
  // 	overflow: hidden;
  // 	text-overflow: ellipsis;

  // }
}

::v-deep .slForm {

  .el-form-item {
    display: flex;
    flex-direction: row;

    .el-form-item__label {
      width: 120px;
      text-align: right;
    }

    .el-form-item__content {
      margin-left: 0 !important;
      flex: 1;
    }

  }
}

.reviewfileList {
  box-shadow: 0 2px 18px rgba(190, 190, 190, 0.31);
  padding: 40px;
  margin-top: 40px;

  .page-title {
    margin: 0 0 40px;
    color: #1f2d3d;
    font-weight: 500;
    font-size: 22px;
    //border-bottom: 1px solid #e6ebf5;
    display: flex;
    align-items: center;
  }

  .page-title i {
    margin-right: 10px;
    font-size: 24px;
    color: #409EFF;
  }

}
</style>
